<div
  class="project-panel-preview__header"
  [ngClass]="{ 'project-panel-preview__header--hidden': hiddenSideNavigation }"
  #header
>
  <div class="project-panel-preview__header__name">
    <h4 *ngIf="projectPreviewService?.project?.fullNameAndAddress">
      <span class="pii">{{ projectPreviewService?.project?.fullNameAndAddress }}</span>
    </h4>
    <div class="d-flex align-items-center">
      <h2>
        <span class="pii">{{ projectPreviewService?.project?.nameAndProjectID }}</span>
      </h2>
      <button
        class="btn-icon project-panel-preview__header__actions__toggle p-0 ml-2"
        *ngIf="notEmptyList()"
        [matMenuTriggerFor]="menu"
      >
        <img src="./assets/img/ic-settings-grey.svg" alt="settings" />
      </button>
      <mat-menu #menu="matMenu" xPosition="before" class="menu-v2">
        <button mat-menu-item (click)="edit()">
          <span>{{ 'Projects.PreviewHeader.edit' | translate }}</span>
        </button>
        <button mat-menu-item (click)="downloadSpec()" *ngIf="projectPreviewService?.project?.specification">
          <span>{{ 'Projects.PreviewHeader.downloadSpec' | translate }}</span>
        </button>
        <button mat-menu-item (click)="remove()" class="hover_red red-500">
          <span>{{ 'Projects.PreviewHeader.remove' | translate }}</span>
        </button>
      </mat-menu>
    </div>
  </div>
  <div class="project-panel-preview__header__actions">
    <app-button
      *ngIf="buttonText || buttonIcon"
      class="mr-1 my-1 my-lg-0"
      (onClick)="emitAction()"
      [config]="{
        size: ButtonSize.SMALL,
        type: ButtonTypes.NEW_PRIMARY_BLUE,
        text: WindowHelper.isMobileWidth ? '' : (buttonText | translate),
        prependSrc: buttonIcon
      }"
    />

    <div class="d-md-none d-block">
      <div class="d-inline-flex">
        <div [matMenuTriggerFor]="stages">
          <app-button
            [class]="'mr-2 bold'"
            [config]="{
              type: ButtonTypes.LIGHT_BLUE,
              text: 'Projects.Stage.' + projectPreviewService?.project?.stage | translate,
              size: ButtonSize.SMALL,
              appendSrc: './assets/img/ic-arrow-down-blue.svg'
            }"
          >
          </app-button>
        </div>
        <mat-menu #stages="matMenu" xPosition="after" class="menu-v2">
          <ng-container *ngFor="let key of Object.keys(ProjectStage)">
            <button
              mat-menu-item
              (click)="onStageChange(ProjectStage[key])"
              [disabled]="projectPreviewService.project.stage === ProjectStage[key]"
              [ngClass]="{
                'hover_red red-500': ProjectStage[key] === ProjectStage.STAGE_LOST,
                'blue-500': projectPreviewService.project.stage === ProjectStage[key]
              }"
            >
              <span>{{ 'Projects.Stage.' + ProjectStage[key] | translate }}</span>
            </button>
          </ng-container>
        </mat-menu>
      </div>
    </div>

    @if (isConfiguratorRoute) {
      <app-button
        class="my-1 my-lg-0 project-panel-preview__header__actions__share"
        (onClick)="copyProjectCreatorLink()"
        [config]="{
          size: ButtonSize.SMALL,
          type: ButtonTypes.NEW_SECONDARY_BLUE,
          prependSrc: '/assets/img/ic-share.svg'
        }"
      />
    }
  </div>
</div>
<div class="d-md-none d-block overflow-hidden">
  <div class="d-flex justify-content-center">
    <div class="category-list">
      <div class="category-list__item" *ngFor="let i of tabs">
        <a
          draggable="false"
          (click)="$event.preventDefault(); tabSelect(i)"
          [routerLink]="i.id"
          [routerLinkActive]="'category-list__item-wrapper--active'"
          class="category-list__item-wrapper"
        >
          <div>
            <svg-icon [src]="i.icon" />
          </div>
          <div>
            {{ i.text }}
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
